{
  "version": 1,
  "asset_id": "e68f25bb-6f88-4cce-8b25-232a0675360f",
  "project_id": "7948fbe6-b4e3-485f-995c-f8f53bd7ab6b",
  "url": "/__l5e/assets-v1/e68f25bb-6f88-4cce-8b25-232a0675360f/arwen-spiral-stair.jpg",
  "r2_key": "a/v1/7948fbe6-b4e3-485f-995c-f8f53bd7ab6b/e68f25bb-6f88-4cce-8b25-232a0675360f/arwen-spiral-stair.jpg",
  "original_filename": "arwen-spiral-stair.jpg",
  "size": 2810616,
  "content_type": "image/jpeg",
  "created_at": "2026-07-05T03:32:46Z"
}
